export default __webpack_public_path__ + "static/media/whatsapp withe.be571a7c.svg";